import { PieChartProps } from "../../../constants/statistics";
import React from "react";

const PieChart: React.FC<PieChartProps> = ({ data, size = 200 }) => {
  const total = data.reduce((sum, item) => sum + Number(item.value), 0);
  
  const gradientSlices = data.reduce<{ gradient: string[], startAngle: number }>(
    (acc, item) => {
      if (item.value > 0) {
        const percentage = (item.value / total) * 100;
        const endAngle = acc.startAngle + percentage;
        acc.gradient.push(`${item.color} ${acc.startAngle}% ${endAngle}%`);
        acc.startAngle = endAngle;
      }
      return acc;
    },
    { gradient: [], startAngle: 0 }
  );

  return (
    <div
      className="eventsPieDiagram"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "32px",
        fontWeight: 300,
        position: "relative",
      }}
    >
      {/* Круговая диаграмма */}
      <div
        style={{
          width: size,
          height: size,
          minWidth: size,
          borderRadius: "50%",
          background: `conic-gradient(${gradientSlices.gradient.join(", ")})`,
        }}
      />
      <div
        style={{
          background: "#FFF",
          width: size / 2,
          height: size / 2,
          left: size / 4,
          position: "absolute",
          borderRadius: "50%",
        }}
      />

      {/* Легенда */}
      <div>
        {data.filter(item => item.value > 0).map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <div
              style={{
                width: "16px",
                height: "16px",
                backgroundColor: item.color,
                marginRight: "8px",
              }}
            />
            <span>
              {item.label} ({item.value})
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChart;